import {
  ProductPaginationListConfigService,
  ProductService,
  AuthService,
  Product,
  AssortmentService
} from 'gung-standard';
import { ListLayout, ListLayoutMultipleComponent, SearchRequest, SearchResult } from 'gung-list';
import { Injectable } from '@angular/core';
import { SjoborgProductPaginationListTableComponent } from '../components/sjoborg-product-pagination-list-table/sjoborg-product-pagination-list-table.component';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { first, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SjoborgProductPaginationListConfigService extends ProductPaginationListConfigService {
  private searchFlow = 'sSEARCH';

  constructor(
    protected productService: ProductService,
    authService: AuthService,
    private assortmentService: AssortmentService
  ) {
    super(productService, authService);
  }

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgProductPaginationListTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }

  getPagedItems(request: SearchRequest): Observable<SearchResult<Product>> {
    const searchRequest: SearchRequest = {
      ...request,
      assortment: this.searchFlow
    };
    return this.productService.getPagedProducts(searchRequest).pipe(
      switchMap(search => {
        return this.productService.getProductsByIdsUnfiltered(search.items.map(p => p.id)).pipe(
          first(),
          switchMap(productsUnfiltered => {
            search.items = search.items.map(p => {
              const productUnfiltered = productsUnfiltered.find(pu => pu.id === p.id);

              return {
                ...p,
                extra: {
                  ...p.extra,
                  ...(productUnfiltered.extra || {})
                }
              };
            });
            return of(search);
          })
        );
      })
    );
  }

  getSearchButtonEnabled(): boolean {
    return true;
  }

  getSearchButtonText(): string {
    return 'SEARCH';
  }
}
